import {i18n} from 'next-i18next'

export const localise = (key, params) => {
  const t = i18n?.t
  if (!key || !t) {return ''}
  return t(key, params)
}
